const model = {
    name: 'SortItem',
    properties: {
        name: { required: true },
        order: {},
    },
};
export default model;
